module.exports = __webpack_public_path__ + "static/media/BAP2.4a100735.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/tutorials/BAP2.png
 ** module id = 680
 ** module chunks = 0
 **/